import React from "react";
import { useParams } from "react-router-dom";
import { touristVehiclesData } from "./touristVehiclesData";
import "./TouristVehicles.css";

const TouristVehicles = () => {
  const { id } = useParams();
  const vehicle = touristVehiclesData[id];

  if (!vehicle) {
    return <h2 style={{ textAlign: "center", margin: "50px" }}>Vehicle not found!</h2>;
  }

  return (
    <div className="TouristVehicles-container">
      <div className="TouristVehicles-main">
        <h2 className="TouristVehicles-title">
          <strong>{vehicle.title}</strong>
        </h2>

        <div className="TouristVehicles-image">
          <img src={vehicle.image} alt={vehicle.title} />
        </div>

        <p className="TouristVehicles-description">{vehicle.description}</p>

        {/* Booking Info */}
        <div className="TouristVehicles-card TouristVehicles-booking-info">
          <h4>Booking Info</h4>
          <p><strong>Make:</strong> {vehicle.bookingInfo.make}</p>
          <p><strong>Seats:</strong> {vehicle.bookingInfo.seats}</p>
          <p><strong>Driver Charges:</strong> {vehicle.bookingInfo.driverCharges}</p>
          <p><strong>Outstation Fare:</strong> {vehicle.bookingInfo.outstationFare}</p>
          <p><strong>Local Fare:</strong> {vehicle.bookingInfo.localFare}</p>
          <button className="TouristVehicles-btn-book">BOOK NOW</button>
        </div>

        {/* Features */}
        <div className="TouristVehicles-facilities">
          <h3>Features & Facilities</h3>
          <ul>
            {vehicle.features.map((f, index) => (
              <li key={index}>{f}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TouristVehicles;
